import React, { PureComponent } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'pui-react-grids'
import MeSideMenu from '../../common/MeSideMenu'

import { refreshUserCounts } from '../../actions'

import WantedItems from './WantedItems'
import Wanted from './Wanted'
import OwnedItems from './OwnedItems'
import ItemsICanGet from './ItemsICanGet'
import Swaps from './Swaps'
import Ecoins from './Ecoins'
import MediaQuery from 'react-responsive'
import breakpoints from '../../styles/breakpoints'

class Me extends PureComponent {
  componentDidMount() {
    this.props.refreshUserCounts()
  }

  render() {
    const { user, counts, match } = this.props

    return (
      <div className="padding">
        <Row>
          <Col lg={5}>
            <MediaQuery minWidth={breakpoints.md}>
              <MeSideMenu user={user} counts={counts} />
            </MediaQuery>
          </Col>
          <Col lg={19}>
            <Switch>
              <Route path={`${match.path}/items/wanted`} component={Wanted} />
              <Route
                path={`${match.path}/items/owned`}
                component={OwnedItems}
              />
              <Route
                path={`${match.path}/items/can-get`}
                component={ItemsICanGet}
              />
              <Route path={`${match.path}/ecoins`} component={Ecoins} />
              <Route
                path={`${match.path}/swaps/:type(proposte|accettate|archivio)`}
                component={Swaps}
              />
              <Redirect
                from={`${match.path}/swaps`}
                to={`${match.path}/swaps/proposte`}
              />
              <Redirect from="" to={`${match.path}/items/wanted`} />
            </Switch>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  counts: state.loggedUserCounts.counts,
})

export default connect(mapStateToProps, {
  refreshUserCounts,
})(Me)



// WEBPACK FOOTER //
// ./src/pages/Me/Me.js